export default "/fonts/RV-Harmonia-Regular.svg?e2fec25e098591d07d96f38909b918a4";